/**
 * Removes empty object keys from an object
 * @param {T} obj
 * @returns {Partial<T>}
 */
const removeEmptyObjectKeys = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value !== null && value !== undefined && value !== '') {
            acc[key] = value;
        }
        return acc;
    }, {});
};
export const useTrackingUtils = () => {
    /**
     * Tracks custom events in GA.
     *
     * @param {string} args.event
     * @returns {void}
     */
    const trackEvent = ({ event, ...props }) => {
        if (!window.dataLayer)
            return;
        const options = removeEmptyObjectKeys(props);
        // eslint-disable-next-line no-unused-vars
        window.dataLayer.push(function () {
            this.reset();
        });
        window.dataLayer.push({
            event,
            ...options,
        });
    };
    return {
        trackEvent,
    };
};
